export const environment = {
	baseUrl: 'https://kairos-stg.gainkodex.com',
	production: false,
	// Staging keeps the "Firmar simulado" bypass for testing without a tablet.
	allowSimulatedSign: true,
	pathBackend: 'https://kairos-stg.gainkodex.com/api/v1',
	// GA4 through GTM (21/09) — see docs/analitica/GA4.md. The container is the
	// public website's, so web and app report to the same GA4 stream.
	// Staging: loads ONLY while debugging (`?gtm_debug`). Its host is not
	// kairosmerit.ae, and the container's Google tag fires on any host, so
	// loading it always would pour test traffic into the production property.
	gtm: { containerId: 'GTM-W247XMFM', onlyWhenDebugging: true },
	get API_URL(): string {
		return this.pathBackend;
	},
};
